export const calcFloatBtnPosition = () => {
  const processLinkBtn = document.getElementById("btn-process-link");
  const formProcessModal = document.getElementById("process-form-modal");
  const whatsBtn = document.getElementById("btn-whats-link");
  const scrollBtn = document.getElementById("scroll-button");

  formProcessModal.style.visibility = "visible";
  const { top: btnTop, height: btnHeight } =
    processLinkBtn.getBoundingClientRect();
  const { height: modHeight } = formProcessModal.getBoundingClientRect();
  const alignedPositionToBtn = btnTop - modHeight + btnHeight;
  formProcessModal.style.top = `${alignedPositionToBtn}px`;

  // Fix position whats btn
  const { height: whatsHeight } = whatsBtn.getBoundingClientRect();
  const alignedPosToBtn = btnTop + whatsHeight + 5;
  whatsBtn.style.top = `${alignedPosToBtn}px`;

  // Fix position scroll btn
  const alignedPoToBtn = btnTop + btnHeight + whatsHeight + 15;
  scrollBtn.style.top = `${alignedPoToBtn}px`;
};

export const openFormProcessModal = () => {
  const processLinkBtn = document.getElementById("btn-process-link");
  const formProcessModal = document.getElementById("process-form-modal");
  processLinkBtn.addEventListener("click", (e) => {
    if (e.target !== e.currentTarget) return;
    e.preventDefault();
    if (formProcessModal) {
      formProcessModal.classList.toggle("visible-none");
    }
  });
};

export const closeFormProcessModal = () => {
  const processLinkBtn = document.getElementById("btn-process-link");
  const formProcessModal = document.getElementById("process-form-modal");
  document.addEventListener("click", (e) => {
    const pageClicked = e.target;
    const modalIsVisible = !formProcessModal.classList.contains("visible-none");
    const modalClicked = !formProcessModal.contains(pageClicked);
    if (
      modalIsVisible &&
      !processLinkBtn.contains(pageClicked) &&
      modalClicked
    ) {
      formProcessModal.classList.add("visible-none");
    }
  });
};
